import { validateProfileAPI } from "@/components/dashboard/recommended/recommendedJobCard/query";

export const isAppWebView = () =>
  typeof window.MessageHandler?.postMessage === "function";

export const postMessageToApp = (type: string) => {
  if (!isAppWebView()) {
    return false;
  }

  window.MessageHandler!.postMessage(JSON.stringify({ type }));
  return true;
};

//Refresh for the appview
export const disableAutoApplyApp = () => postMessageToApp("AUTOAPPLY_DISABLED");

const getProfileData = async () => {
  try {
    const data = await validateProfileAPI();

    return data;
  } catch (error) {
    console.error("Failed to validate profile ", error);
  }
};

export const handleViewPreferences = async () => {
  const data = await getProfileData();

  if (!data) {
    return {
      data: null,
      handledByApp: false,
    };
  }

  const actionType = data?.actionType ? "OPEN_L1_APOP" : "OPEN_AUTOAPPLY_SHEET";

  if (postMessageToApp(actionType)) {
    return {
      data,
      handledByApp: true,
    };
  }

  return {
    data,
    handledByApp: false,
  };
};
